import { useState, useEffect, useRef } from 'react';
import { Document, Page } from 'react-pdf';
import pdf_file from "../../Assets/Resume.pdf";
import Button from "react-bootstrap/Button";
import { pdfjs } from 'react-pdf';
import './Resume.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const Resume = () => {
  const resumeRef = useRef(null);
  const [width, setWidth] = useState(1200);
  
  useEffect(() => {
    setWidth(window.innerWidth);
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    }, {
      threshold: 0.2,
    });
    
    const node = resumeRef.current;
    if (node) {
      observer.observe(node);
    }
    
    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, []);

  return (
    <section className="resume-section" id="resume">
      <div ref={resumeRef} className="resume-container">
        <div className="resume-content">
          <div className="resume-title">
            <h1>Download My 
            <span className="gradient"> Resume </span>
            </h1>
            <Button
              variant="primary"
              href={pdf_file}
              target="_blank"
              className="download-button" 
              style={{ justifyContent: "center", position: "relative"}}
            >
              <i className="fas fa-download"></i> Download Resume 
            </Button>
          </div>
          <div className="resume-pdf">
            <Document 
              file={pdf_file} 
              className="pdf-document"
              loading="Loading Resume..."
            >
              <Page 
                pageNumber={1} 
                scale={width > 786 ? 1.7 : 0.6}
                className="pdf-page"
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </Document>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;